"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValidationClassMap = void 0;
exports.defaultValidationClassMap = {
    invalid: '--invalid',
    valid: '--valid'
};
//# sourceMappingURL=valid-marker.contracts.js.map